export default "__VITE_ASSET__Big6DOZq__"